var $dcdf0bd0beea70a8$exports = {};
$dcdf0bd0beea70a8$exports = {
    "dismiss": `Dismiss`,
    "alert": `Alert`
};


export {$dcdf0bd0beea70a8$exports as default};
//# sourceMappingURL=en-US.mjs.map
